class PricingSocketService {
  constructor() {
    if (new.target === PricingSocketService) {
      throw new Error("Cannot instantiate an abstract class.");
    }
    if (this.connect === PricingSocketService.prototype.connect) {
      throw new Error("Class extending PricingSocketService must override 'connect({ onConnected, onDisconnected, onPaymentEvent, onError })'.");
    }
    if (this.disconnect === PricingSocketService.prototype.disconnect) {
      throw new Error("Class extending PricingSocketService must override 'disconnect()'.");
    }
  }

  connect({ onConnected, onDisconnected, onPaymentEvent, onError }) {
    throw new Error("Method 'connect({ onConnected, onDisconnected, onPaymentEvent, onError })' must be implemented.");
  }

  disconnect() {
    throw new Error("Method 'disconnect()' must be implemented.");
  }
}

export default PricingSocketService;
